import uniq from "lodash/uniq";
import uniqWith from "lodash/uniqWith";

import { FindingFilterItems, RulesetFilterItem } from "@types";

import { Finding } from "@pages/findings/types";

export const getDemoFilterItems = (
  filteredFindings: Finding[]
): FindingFilterItems => {
  if (filteredFindings.length === 0) {
    return {
      repoNames: [],
      policyItems: [],
      rulesetItems: [],
      refs: [],
    };
  }
  // there will only be one repo for the demo findings
  const repoNames = [filteredFindings[0].repository.name ?? ""];

  const policyItems = uniq(
    filteredFindings.map((f) => {
      // get policy item from finding
      return {
        name: f.finding.metadata?.["semgrep.policy"]?.name ?? "",
        slug: f.finding.metadata?.["semgrep.policy"]?.slug ?? "",
      };
    })
  );

  let rulesetItems = filteredFindings.flatMap((f) => {
    let rulesetAndRule: RulesetFilterItem[] = [
      {
        name: f.finding.check_id,
        type: "Rule",
      },
    ];
    // get ruleset if it exists
    if (f.finding.metadata?.["semgrep.ruleset"]) {
      rulesetAndRule = rulesetAndRule.concat([
        {
          name: f.finding.metadata["semgrep.ruleset"],
          type: "Ruleset",
        },
      ]);
    }
    return rulesetAndRule;
  });

  // remove duplicates
  rulesetItems = uniqWith(
    rulesetItems,
    (r1, r2) => r1.name === r2.name && r1.type === r2.type
  );

  // again, there will only be one ref for the demo findings
  const refs = [filteredFindings[0].ref];

  return {
    repoNames,
    policyItems,
    rulesetItems,
    refs,
  };
};
